<template>
	<div class="wrap">
		<div class="bg">
			<span class="f0">{{tagNo}}</span>
			<div class="p1">
				<span class="f11" @click="go(data[0])">{{data[0]}}</span>
				<span class="f12" @click="go(data[1])">{{data[1]}}</span>
			</div>
			<div class="p2">
				<span class="f21" @click="go(data[2])">{{data[2]}}</span>
				<span class="f22" @click="go(data[3])">{{data[3]}}</span>
				<span class="f23" @click="go(data[4])">{{data[4]}}</span>
				<span class="f24" @click="go(data[5])">{{data[5]}}</span>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {

		props: {
			title: {
				type: String,
				default: '',
			},
			tagNo:{
				type: String,
				default: 'A1000000003',
			},
		},
		data() {
			return {
				data1:[
					'230304010201',
					'230304010401',
					'230304010026',
					'230304010091',
					'230304010073',
					'230304010011',
				],
				data2:[
					'230304010219',
					'230304010467',
					'230304010006',
					'230304010032',
					'230304010023',
					'230304010051',
				],
				data:[]
			};
		},
		async created() {
			if(this.$route.name=='archive'){
				this.data=this.data2
			}else{
				this.data=this.data1
			}
		},
		
		methods: {
			go(tagNo){
				console.log(this.$route.name=='archive')
				if(this.$route.name=='archive'){
					this.$router.push({ name: 'farchive',params:{
						tagNo:tagNo,temperature:'38.4'
					} })
				}else{
					this.$router.push({ name: 'archive',params:{
						tagNo:tagNo,temperature:'38.4'
					} })
				}
				 // this.$router.push({ path: '/archive' })
				 
			}
			

		},
	};
</script>
<style lang="scss" scoped>
	.wrap {
		padding: 0.31rem 0.14rem 0.51rem;
		display: flex;
		flex: 1;
		.bg{
			width: 100%;
			background: url('../../../../assets/yq/family.png');
			background-repeat: no-repeat;
			    background-size: contain;
			flex: 1;
			display: flex;
			align-items: center;
			position: relative;
			// <div class="bg">
			// 	<span class="f0"></span>
			// 	<div class="p1">
			// 		<span class="f11"></span>
			// 		<span class="f12"></span>
			// 	</div>
			// 	<div class="p2">
			// 		<span class="f21"></span>
			// 		<span class="f22"></span>
			// 		<span class="f23"></span>
			// 		<span class="f24"></span>
			// 	</div>
				
			// </div>
			.f0,.f11,.f12,.f21,.f22,.f23,.f24{
				display: inline-block;
				width: 1.25rem;
				height: 0.31rem;
				line-height: 0.31rem;
				text-align: center;
				color: #000;
				font-size: 0.15rem;
				transform: scale(0.8);
				cursor: pointer;
			}
			.f0{
				    cursor: default;
				top: 0.5rem;
				left: 50%;
				transform:scale(0.8) translateX(-60%);
				position: absolute;
			}
			.p1{
				position: absolute;
				top: 2.23rem;
				width: 100%;
				padding: 0 0.7rem;
				display: flex;
				    justify-content: space-between;
			}
			.p2{
				bottom: 0;
				width: 100%;
				position: absolute;
				display: flex;
				    justify-content: space-between;
			}
		}
		

		
	}
</style>